import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Opens a dish's screen, as tapping its card in the menu does: a required single choice
 * starts on its first value, and extras start unchosen, since the server charges for every
 * extra sent with the order.
 */
export default function useOpenDish({
  orderList,
  setCookingLevel,
  setRemoveIngredients,
  setSelectedItem,
}) {
  const navigate = useNavigate();
  return useCallback(
    (item) => {
      const data = {
        ...item,
        name:
          orderList?.items?.length > 0 ? orderList?.items[0]?.name || "" : "",
        id: Math.random().toString(36).substr(2, 9),
      };
      navigate(`/customize/${item?.translations?.name}`, { state: data });
      setSelectedItem(data);
      const singleOption = item?.options?.find(
        (opt) => opt.selection_type === "single_choice"
      );
      setCookingLevel(
        singleOption?.values?.[0]?.name ? [singleOption.values[0].name] : []
      );
      setRemoveIngredients([]);
    },
    [orderList, navigate, setCookingLevel, setRemoveIngredients, setSelectedItem]
  );
}
